<template>
  <div class="common-box" style="height:388px;">
    <el-row class="row-one">
      <span class="row-one-title">点财通会员交易</span>
    </el-row>
    <form id="payForm" name="pay" method="post" action="https://aggpc.fuioupay.com/inteGate.fuiou">
      <input type="hidden" id="mchnt_cd" name="mchnt_cd" />
      <input type="hidden" id="order_date" name="order_date" />
      <input type="hidden" id="order_id" name="order_id" />
      <input type="hidden" id="pay_type" name="pay_type" value="QUICKPAY">
      <input type="hidden" id="order_amt" name="order_amt" />
      <input type="hidden" id="page_notify_url" name="page_notify_url" />
      <input type="hidden" id="back_notify_url" name="back_notify_url" />
      <input type="hidden" id="goods_name" name="goods_name" />
      <input type="hidden" id="rem" name="rem" />
      <input type="hidden" class="form-control" id="sign" name="sign" value="">
    </form>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      orderParams: ''
    }
  },
  created () {
    this.orderParams = this.$route.params
  },
  mounted () {
    this.getFyOrder()
  },
  methods: {
    getFyOrder () {
      this.$http.post(this.$apiPath.orderPc, {
        custno: this.$commonJs.getCookie('u_custno1'),
        order_amt: this.orderParams.order_amt,//this.orderParams.order_amt
        goods_name: this.orderParams.goods_name,
        type: this.orderParams.type,
        beginyear: this.orderParams.beginyear,
        beginmonth: this.orderParams.beginmonth,
        beginday: this.orderParams.beginday,
        endyear: this.orderParams.endyear,
        endmonth: this.orderParams.endmonth,
        endday: this.orderParams.endday,
        page_notify_url: "https://trade.myfund.com/personal/#/memberPayResult"
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200" && res.data.success) {
          const resDate = res.data.data
          var sign = resDate.sign;
          var mchnt_cd = resDate.mchnt_cd;//商户号
          var order_date = resDate.order_date;//订单日期
          var order_id = resDate.order_id;//订单号
          var order_amt = resDate.order_amt;//订单金额
          var page_notify_url = "https://trade.myfund.com/personal/#/memberPayResult";//前端通知地址,必须是商户交易系统的地址  https://trade.myfund.com/personal/#/memberPayResult  https://trade.myfund.com/kfit/page/fuiou/payResult.jsp
          var back_notify_url = "http://apptrade.myfund.com:7003/appnew/fy/payAdvicePc";//后端通知地址,必须是商户交易系统的地址
          var goods_name = resDate.goods_name;
          var rem = "";
          window.sessionStorage.setItem('order_date', order_date)
          window.sessionStorage.setItem('order_amt', order_amt)
          window.sessionStorage.setItem('order_id', order_id)
          // console.log(sign, mchnt_cd, order_date, order_id, order_amt, page_notify_url, back_notify_url, goods_name, rem);
          this.submitForm(sign, mchnt_cd, order_date, order_id, order_amt, page_notify_url, back_notify_url, goods_name, rem)
        }
      }).catch(err => { })
    },
    submitForm (sign, mchnt_cd, order_date, order_id, order_amt, page_notify_url, back_notify_url, goods_name, rem) {
      $("#mchnt_cd").val(mchnt_cd);
      $("#order_date").val(order_date);
      $("#order_id").val(order_id);
      $("#order_amt").val(order_amt);
      $("#page_notify_url").val(page_notify_url);
      $("#back_notify_url").val(back_notify_url);
      $("#goods_name").val(goods_name);
      $("#rem").val(rem);
      $("#sign").val(sign);
      $("#payForm").submit();
    }
  }
}
</script>